import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { DossierIntervention } from 'app/models/dossier_intervention.model';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { HeureTravailleeService } from 'app/services/heure-travaillee.service';
import { UserService } from 'app/services/user.service';
import { User } from 'app/models/user.model';
import { HeureTravaillee } from 'app/models/heureTravaillee.model';

@Component({
  selector: 'app-heure-travaillee',
  templateUrl: './heure-travaillee.component.html',
  styleUrls: ['./heure-travaillee.component.scss']
})
export class HeureTravailleeComponent implements OnInit {
  @Input() currentDossierIntervention: DossierIntervention;
  @Output() submitEvent = new EventEmitter();
  @Output() valueChangedEvent = new EventEmitter();

  users: User[];
  success: boolean = false;
  error: boolean = false;

  heureTravailleeForm: FormGroup;

  constructor(private heureTravailleeService: HeureTravailleeService, private userService: UserService, private router: Router) { }

  ngOnInit(): void {
    this.heureTravailleeForm = new FormGroup({
      dossier_intervention_id: new FormControl(this.currentDossierIntervention.id),
      heures_travaillees: new FormArray([]) // Create an empty FormArray for equipements
    });
    this.currentDossierIntervention.heures_travaillees.forEach((heureTravaillee) => {
      this.addHeureTravaille(heureTravaillee);
    });
    this.addHeureTravaille(null);
    this.getTechniciens();

    this.heureTravailleeForm.valueChanges.subscribe(() => {
        this.valueChangedEvent.emit(true);
    });
  }

  getTechniciens() {
    this.userService.getTechniciens().subscribe((users) => {
      this.users = users;
    });
  }

  get heuresTravailleesArray(): FormArray {
    return this.heureTravailleeForm.get('heures_travaillees') as FormArray;
  }
  get heuresTravailleesControlsArray(): FormGroup[] {
    return this.heuresTravailleesArray.controls as FormGroup[];
  }

  addHeureTravaille(heureTravaille?: HeureTravaillee, i?: number): void {
    if (i == null || i == ((<FormArray>this.heureTravailleeForm.get('heures_travaillees')).length - 1)) {
      let validators = null;
      if (i == null && (heureTravaille != null || this.heuresTravailleesControlsArray.length == 0)) {
        validators = Validators.required;
      }

      const heureTravailleeFormGroup = new FormGroup({
        dossier_intervention_id: new FormControl(this.currentDossierIntervention.id),
        user_id: new FormControl(heureTravaille?.user_id, validators),
        date: new FormControl(heureTravaille != null && heureTravaille.date != null ? heureTravaille.date : new Date().toISOString().slice(0, 10), validators),
        heure_depart: new FormControl(heureTravaille?.heure_depart, null),
        heure_retour: new FormControl(heureTravaille?.heure_retour, null),
        diner: new FormControl(heureTravaille?.diner, validators),
        temps: new FormControl(heureTravaille?.temps, null),
      });

      if (i != null) {
        this.heuresTravailleesControlsArray[i].controls.user_id.addValidators(Validators.required);
        this.heuresTravailleesControlsArray[i].controls.heure_depart.addValidators(Validators.required);
        this.heuresTravailleesControlsArray[i].controls.heure_retour.addValidators(Validators.required);
      }

      (this.heureTravailleeForm.get('heures_travaillees') as FormArray).push(heureTravailleeFormGroup);
    }
  }

  onFormSubmit() {
    this.error = false;
    this.success = false;
    this.heureTravailleeForm.markAllAsTouched();

    if (this.heureTravailleeForm.valid) {
      const formData = this.heureTravailleeForm.value;
      this.heureTravailleeService.storeForDossierIntervention(formData).subscribe(
        (response) => {
          this.success = true;
          this.submitEvent.emit(this.currentDossierIntervention.id);
          this.valueChangedEvent.emit(false);
        }, (error) => { this.error = true; this.showErrors(error); }
      );
    }
  }

  compareUsersSelect(user1: any, user2ID: any): boolean {
    return user1.id == user2ID;
  }

  compareDinerSelect(diner1: any, diner2: any): boolean {
    return diner1 == diner2;
  }


  showErrors(error: any) {
    //Gestion des erreurs laravel
    if (error instanceof HttpErrorResponse) {
      for (const key in error.error.errors) {
        //Todo
      }
    }
    else {
      error.forEach((element) => {
        //this.toastr.error(element);
      });
    }
  }
}
